// ============================================
// search
// ============================================

function search() {
	const search = document.querySelector('.js-search');
	if (search) {
		const trigger = document.querySelectorAll('.js-search-trigger');
		const contents = document.querySelector('.js-search-contents');
		const bg = document.querySelector('.js-search-bg');
		const close = document.querySelector('.js-search-close');
		//モーダルを開く
		for (let i = 0; i < trigger.length; i++) {
			trigger[i].addEventListener('click', () => {
				if(!contents.classList.contains('is-active')){
					contents.classList.add('is-active');
				}
			})
		}
		//モーダルを閉じる
		bg.addEventListener('click', () => {
			closeAction();
		})
		close.addEventListener('click', () => {
			closeAction();
		})
		function closeAction(){
			contents.classList.remove('is-active');
		}
	}
}

// ============================================
// エクスポート
// ============================================
export { search };